import { useTranslation } from 'next-i18next';
import Router from 'next/router';

interface Props {
  tags: any;
  onClose?: () => void;
}

const TagBadges = ({ onClose, tags }: Props) => {
  const { t } = useTranslation('common');

  const handleClick = (path: string) => {
    Router.push(path);
    if (onClose) {
      onClose();
    }
  };
  return (
    <div className="mt-4 flex w-full flex-row items-start border-opacity-60">
      <span className="text-sm font-semibold capitalize text-heading ltr:mr-6 rtl:ml-6">
        {t('text-tags')}
      </span>
      <div className="flex flex-row flex-wrap">
        {tags?.map((tag: any) => (
          <button
            onClick={() => handleClick(`/search?tags=${tag.slug}`)}
            key={tag.id}
            className="mb-2 whitespace-nowrap rounded border border-border-200 bg-gray-100 px-1 text-sm lowercase tracking-wider text-heading transition-colors hover:border-accent hover:text-accent focus:bg-opacity-100 focus:outline-0 ltr:mr-2 rtl:ml-2"
          >
            #{tag.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TagBadges;
